import { customerApi } from '../api';
import { ICustomer } from '../model/customer.model';
import { ACTION_TYPES } from './store/customer.actions';

export const updateCustomer = (param: any) => async (dispatch, getState) => {
  const { customer } = await getState();
  await dispatch({ type: ACTION_TYPES.UPDATE_CUSTOMER, payload: { ...customer, ...param } });
};

export const saveCustomer = (customer: ICustomer) => async dispatch => {
  const result = await customerApi.saveCustomer(customer);
  return result.isSuccess;
};

export const submitStep = (avForm: any) => async dispatch => {
  const arrayCustomer = {};
  Object.keys(avForm.current._inputs).map(fieldName => {
    arrayCustomer[fieldName] = avForm.current._inputs[fieldName].value;
  });
  await dispatch(updateCustomer(arrayCustomer));
};
